
    import { css } from 'lit-element';
    export default css`:host{display:block;overflow-wrap:anywhere;word-break:break-word}a{color:var(--gigg-primary-color);overflow-wrap:anywhere;word-break:break-word}`;
  